import { ReactNode, ComponentType } from "react";

interface SectionCardProps {
  title: string;
  icon?: ComponentType<{ className?: string }>;
  action?: ReactNode;
  badge?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
  className?: string;
  id?: string;
  variant?: "default" | "danger";
}

export function SectionCard({
  title,
  icon: Icon,
  action,
  badge,
  footer,
  children,
  className = "",
  id,
  variant = "default",
}: SectionCardProps) {
  const isDanger = variant === "danger";

  return (
    <div
      className={`rounded-2xl border bg-background/80 shadow-xl overflow-hidden ${isDanger ? "border-red-200 dark:border-red-800" : ""} ${id ? "scroll-mt-24" : ""} ${className}`}
      data-testid="section-card"
      id={id}
    >
      <div className="flex items-center justify-between px-4 min-h-12 border-b bg-background/50">
        <div className="flex items-center gap-2">
          {Icon && <Icon className={`size-4 ${isDanger ? "text-red-500" : "text-primary"}`} />}
          <span className={`font-semibold text-sm ${isDanger ? "text-red-900 dark:text-red-100" : ""}`}>
            {title}
          </span>
        </div>
        <div className="flex items-center gap-2">
          {badge}
          {action}
        </div>
      </div>
      <div className="px-4">{children}</div>
      {footer && (
        <div className="px-4 py-2.5 bg-surface/20 border-t text-xs text-surface-foreground/60">
          {footer}
        </div>
      )}
    </div>
  );
}